jQuery(function () {
  const domReady = (cb) => {
    if (typeof wp !== "undefined" && wp.domReady) wp.domReady(cb);
    else cb();
  };

  const once = (eventName, cb) => {
    document.addEventListener(eventName, cb, { once: true });
  };

  const whenGsapReady = (cb) => {
    if (window.gsap) return cb();
    once("longevity:gsap-ready", cb);
  };

  const whenScrollReady = (cb) => {
    let ran = false;
    const runOnce = () => {
      if (ran) return;
      ran = true;
      cb();
    };
    once("longevity:scroll-ready", runOnce);
    setTimeout(runOnce, 0);
  };

  const isEditor =
    document.body.classList.contains("block-editor-page") ||
    document.body.classList.contains("wp-admin");

  domReady(() => {
    if (isEditor) return;
    whenGsapReady(() => {
      whenScrollReady(() => {
        initOurValues();
      });
    });
  });

  function initOurValues() {
    const blocks = document.querySelectorAll(".js-our-values");
    if (!blocks.length) return;

    const gsap = window.gsap;
    if (!gsap) return;

    const ScrollTrigger =
      window.ScrollTrigger ||
      (gsap.core && gsap.core.globals && gsap.core.globals().ScrollTrigger) ||
      null;

    if (ScrollTrigger && gsap.registerPlugin) {
      try {
        gsap.registerPlugin(ScrollTrigger);
      } catch (e) {}
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    blocks.forEach((block) => {
      if (block.dataset.ovInit === "1") return;
      block.dataset.ovInit = "1";

      const items = Array.from(block.querySelectorAll(".js-ov-item"));
      if (!items.length) return;

      if (reduceMotion) {
        gsap.set(items, { autoAlpha: 1, y: 0, clearProps: "transform" });
        return;
      }

      gsap.set(items, { autoAlpha: 0, y: 18 });

      const vars = {
        autoAlpha: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        stagger: 0.08,
        clearProps: "transform",
      };

      if (ScrollTrigger) {
        vars.scrollTrigger = {
          trigger: block,
          start: "top 78%",
          once: true,
          invalidateOnRefresh: true,
        };
      }

      gsap.to(items, vars);
    });
  }
});

